const state = {
    list: [
        {
            lat: 37.773972,
            lng: -122.431297,
            country: 'United States',
            status: 'YELLOW',
            cities: ['Atlanta', 'Boston', 'Chicago', 'Dallas', 'Denver', 'New-York', 'San Diego', 'San Francisco', 'Seattle', 'St. Louis', 'Washington']
        },
        {
            lat: 32.715736,
            lng: -117.161087,
            country: 'United States',
            status: 'RED',
            cities: ['Los Angeles', 'Miami', 'Minneapolis-St. Paul', 'New-York', 'San Diego', 'San Francisco', 'Seattle', 'St. Louis', 'Washington']
        },
        {
            lat: 44.33,
            lng: -69.73,
            country: 'United States',
            status: 'GREEN',
            cities: ['Anson', 'Ashland', 'Berwick', 'Bingham', 'Bowdoinham', 'Bridgton', 'Seattle', 'St. Louis', 'Washington']
        },
    ]
};

const getters = {
    GET_MARKERS_LIST: state => state.list.map(el => (
        {
            ...el,
            icon: {
                url: '/img/svg/pin-4.svg',
                scaledSize: {width: 32, height: 40},
                labelOrigin: {x: 16, y: -10}
            },
            color: `bg-${el.status.toLowerCase()}`,
            image: `marker-${el.status.toLowerCase()}.png`
        }
    ))
}

const mutations = {
    SET_MARKERS_LIST(state, data) {
        state.list = data;
    }
};

const actions = {
    async ACT_MARKERS_LIST ({commit}, data) {
        await commit('SET_MARKERS_LIST', data);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
}
